<template>
	  <div :style="`backgroundColor:${ui.bg_color};width: 100%;`">
        <template>
          <img src="../../assets/image/new_img/total_ticket_black.png" alt="" class="total_ticket" v-if="ui.bg_color == '#FFFFFF'"/>
          <img src="../../assets/image/new_img/total_ticket_white.png" alt="" class="total_ticket" v-else/>
        </template>
        <div class="hot_remain_ticket_continer">
          <img src="../../assets/image/new_img/hot.png" alt="" class="remain_hot">
          <div class="right_remain_continer red_continer">
            <span class="left_tip size_38">剩余门票</span>
            <div>
              <remainTicketNum></remainTicketNum>
            </div>
            <!-- <div class="remain_continer">
              <span v-for="(item,index) in remain_ticket" class="remain_txt">{{item}}</span>
            </div> -->
            <span class="left_tip size_38">张</span>
          </div>
        </div>
        <div class="main_form main_form_fourth_base">
            <div class="left_price_continer">
              <div>
                <span class="mini_money_type">￥</span>
                <span class="price_txt">30</span>
              </div>
              <div>
                <span class="mb_6 size_30">贵宾门票</span>
                <br>
                <span class="size_30">免费入场</span>
              </div>
            </div>
            <div class="right_collect_ticket_txt">
<!--              :style="`color: ${is_stop  ? 'rgba(255,255,255,0.5)': '#fff' }`"-->
                <div @click="showRealForm" style="color: #fff">
                  <span>点击</span>
                  <span>领票</span>
                </div>
            </div>
            <div class="number_bg_04">
<!--              <img src="../../assets/image/new_img/number_bg_04.png" alt="">-->
              <span>已有{{registeredCount}}人报名</span>
            </div>
            <!-- finger_move -->
          <img src="../../assets/image/new_img/pointer_03.png" alt="" class="form_4_pointer finger_swing">
        </div>
        <div class="form_policy pb_44">
          <policy :custom_col='ui.bg_color == "#FFFFFF" ? "#343434" :"#fff"'></policy>
        </div>

      <!-- 模版四真正表单-->
        <van-popup v-model="form_dialog"  round  closeable
					@close="form_dialog = false"
        class="custom_form_popup">
          <div class="form_popup">
            <h3>请补充您的领票信息</h3>
            <div>
              <p class="lable_p" v-if="is_name">您的姓名</p>
              <van-field
                  v-if="is_name" 
                  v-model="action_form.name"
                  name="姓名"
                  placeholder="请输入您的姓名"
                  class="custom_field"
              />

              <p class="lable_p">您的手机号码(已加密)</p>
              <van-field
                  type="tel"
                  v-model="action_form.phone"
                  name="电话"
                  placeholder="请输入您的手机号码"
                  class="custom_field"
              />

              <template v-if="is_show_car">
                <p class="lable_p">选择您的意向车型</p>
                <van-field
                    v-model="action_form.car_name"
                    readonly
                    placeholder="意向车型（品牌+厂商+车型）"
                    @click="openCarDialog"
                    class="custom_field"
                    :class="is_city==false ? 'mb_15' : ''"
                >
                  <template slot="right-icon">
                    <van-icon name="play" style="transform: rotate(90deg)" color="#a0a4ac"/>
                  </template>
                </van-field>
              </template>
              <!--          v-if="is_city"-->
              <p class="lable_p" v-if="is_city">您所在的城市</p>
              <van-field
                  v-if="is_city"
                  v-model="action_form.city"
                  readonly
                  placeholder="选择您所在的城市"
                  @click="openCityDialog"
                  class="custom_field mb_15"
              >
                <template slot="right-icon">
                  <van-icon name="play" style="transform: rotate(90deg)" color="#a0a4ac"/>
                </template>
              </van-field>

              <!--  按钮-->
              <div class="main_form_btn popup_form_btn">
                <div class="form_btn" @click="submitForm" :style="`backgroundColor: ${ui.btn_bg_color};`">
                  <span :style="`color: ${is_opacity}`">{{ui.btn_text}}</span>
                  <img src="../../assets/image/new_img/pointer_01.png" alt="" class="form_pointer finger_1">
                </div>
              </div>
            </div>
          </div>

        </van-popup>
      </div>
</template>

<script>
  import countDown from "@/components/countDown";
  import policy from "@/components/policy";
  import copyright from "@/components/copyright";
  import banner from "@/components/banner";
  import carlist_img from "@/components/carlist_img";
  import carlist_noimg from "@/components/carlist_noimg";
  import remainTicketNum from "@/components/remainTicketNum.vue";
  import { mapGetters } from 'vuex';
  export default {
		mame: "formSix",
    components: {
      countDown,
      policy,
      copyright,
      banner,
      carlist_img,
      carlist_noimg,
      remainTicketNum
    },
    data() {
      return {
				form_dialog: false,
        // is_name:true //是否显示姓名
      };
    },
    props: {
     ui: {
        type: Object,
        default: () => ({}),
      },
      stime: {
        type: Number,
        default: 0,
      },
      action_form: {
        type: Object,
        default: () => ({}),
      },
      is_dialog_car: {
        type: Boolean,
        default: false,
      },
      is_city: {
        type: Boolean,
        default: false,
      },
      city_show: {
        type: Boolean,
        default: false,
      },
      is_stop: {
        type: Boolean,
        default: false,
      },
      type: {
        type: String,
        default: "",
      },
      remain_ticket: {
        type: Array,
        default: () => [],
      },
      number_1: {
        type: Number,
        default: 0,
      },
      number_2: {
        type: Number,
        default: 0,
      },
      is_opacity: {
        type: String,
        default: '#fff',
      },
			is_show_car: {
        type: Boolean,
        default: true,
      },
      tid:{
          type: Number,
          default: 0
        },
      title:{
        type: String,
        default: ''
      },
      is_name:{
        type: Boolean,
        default: true,
      },
    },

    methods: {
      submitForm() {
        this.$emit("submitForm");
      },
      openCarDialog() {
        this.$emit("openCarDialog");
      },
      openCityDialog() {
        this.$emit("openCityDialog");
      },
			showRealForm(){
				// this.$emit("showRealForm");
				this.form_dialog = true;
			},

    },
     computed: {
      ...mapGetters({
        bigRegisteredCount: 'ticketStore/getBigRegisteredCount',
        registeredCount: 'ticketStore/getRegisteredCount',
      }),
    },
    created(){
      this.$store.dispatch('ticketStore/initializeTicketSystem');
    },
    destroyed(){
      this.$store.commit('ticketStore/cleanupTimers');
    },
   
  }
</script>

<style lang="less" scoped>
  /*todo 表单样式冲突，*/
  @import "../../assets/style/autoshow/base.less";
  @import "../../assets/style/autoshow/form.less";
  // form
  @import "../../assets/style/common/successful.less";
  //报名成功
  @import "../../assets/style/autoshow/base_form.less";
  .pb_44{
    padding-bottom: 44px;
  }
</style>